import { Switch } from '@orobix/orobix-fe-components'
import { useField, useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

interface StartTestSwitchProps {
  fieldName: string
}

const StartTestSwitch = ({ fieldName }: StartTestSwitchProps) => {
  const { t } = useTranslation()
  const { isSubmitting } = useFormikContext()
  const [field, meta, helpers] = useField(fieldName)

  const { name, value } = field
  const { error, touched } = meta
  const { setValue, setTouched } = helpers

  return (
    <div onMouseLeave={() => setTouched(true)}>
      <Switch
        id={`${name}SwitchId`}
        text={t('Start a test with all product images not used in training')}
        title={t(
          'Include all product images not used in training in a test that starts automatically when the training is completed.'
        )}
        isToggled={value}
        disabled={isSubmitting}
        onToggle={() => {
          setValue(!value)
        }}
        error={!!(error && touched)}
        errorMessage={error}
      />
    </div>
  )
}
export default StartTestSwitch
